// extracted by mini-css-extract-plugin
export default {"tabs":"u5-z","tablist":"v5-z","tablistItem":"w5-z"};